import { Theme, ThemeMode } from '@/types/theme';
import { createContext } from 'react';

const preferredTheme: ThemeMode = window.matchMedia(
  '(prefers-color-scheme: dark)',
).matches
  ? 'dark'
  : 'light';

type ThemeProviderState = {
  theme: Theme;
  preferredTheme: ThemeMode;
  setTheme: (theme: Theme) => void;
};

const initialState: ThemeProviderState = {
  theme: 'system',
  preferredTheme,
  setTheme: () => null,
};

const ThemeProviderContext = createContext<ThemeProviderState>(initialState);

export { ThemeProviderContext, preferredTheme };
